const Chlorophyll = () => {
  const StartDate = new datePicker({
    container: '#start-date',
    elementExists: true,
    onChange: () => {
      updateData();
    },
  }).setDate('2024-10-01');

  const EndDate = new datePicker({
    container: '#end-date',
    elementExists: true,
    onChange: () => {
      updateData();
    },
  }).setDate('2025-09-30');

  const season = new Dropdown({
    container: '#season',
    elementExists: true,
    onChange: () => {
      updateData();
    },
  }).val('summer');

  const seasonalConcentrationsReq = {
    url: '/sites/all/scripts/view/chlora_yearly_avg.php',
    table: 'viewer.chlora_avg_yearly_standard_graph',
    fields: ['*'],
    date_field: 'date_time',
    value_field: 'rvalue',
    units_field: 'unit_name',
    standard_field: 'chlora_standard',
    end_year: 2025,
    drupal_user_switch: false,
    drupal_userid: 1,
  };

  const seasonalConcentrationsOpt = {
    container: '#seasonal-concentrations-graph-section',
    chartType: 'scatter with standard line',
    categoryField: 'location',
    colors: ['#23b578'],
    xAxisFormat: '’%y',
    gridlines: true,
    xAxis: true,
    yAxis: true,
    defaultStandardValue: 18,
  };

  const ccrDrilldownReq = {
    url: '/sites/all/scripts/view/chlora_ccr_drilldown.php',
    table: 'viewer.results_simple',
    fields: ['*'],
    date_field: 'rdate',
    value_field: 'rvalue_converted',
    units_field: 'unit_name',
    start_date: StartDate.getDate(),
    end_date: EndDate.getDate(),
    season: season.val(),
    parameter: 24,
    location1: 79,
    location2: 80,
    location3: 81,
    location4: 66,
    sort: 'rdate ASC, location_name ASC, parameter ASC',
    //data: data
    //standard_field: "chlora_standard",
    drupal_user_switch: false,
    drupal_userid: 1,
  };

  const ccrDrilldownOpt = {
    container: '#chlora-ccr-drilldown-graph-section',
    chartType: 'multi-dimensional scatter',
    categoryField: 'location_name',
    categoryField2: 'parameter',
    colors: ['#23b578', '#5C6BC0', '#DD2C00', 'F2C300'],
    gridlines: true,
    xAxis: true,
    xAxisFormat: '%m/%y',
    yAxis: true,
    tooltipDateFormat: 'MMM DD, YYYY',
    legend: true,
  };

  function updateData() {
    ccrDrilldownReq.start_date = StartDate.getDate();
    ccrDrilldownReq.end_date = EndDate.getDate();
    ccrDrilldownReq.season = season.val();

    if (season.val() === 'summer') {
      ccrDrilldownOpt.xAxisFormat = '%m/%d/%y';
    } else {
      ccrDrilldownOpt.xAxisFormat = '%m/%y';
    }

    const ccrDrilldown = new Chart(ccrDrilldownReq, ccrDrilldownOpt);
  }

  const seasonalConcentrations = new Chart(seasonalConcentrationsReq, seasonalConcentrationsOpt);
  const ccrDrilldown = new Chart(ccrDrilldownReq, ccrDrilldownOpt);
};
